import { render, staticRenderFns } from "./freeBoxList.vue?vue&type=template&id=614c5367&scoped=true&"
import script from "./freeBoxList.vue?vue&type=script&lang=js&"
export * from "./freeBoxList.vue?vue&type=script&lang=js&"
import style0 from "./freeBoxList.vue?vue&type=style&index=0&id=614c5367&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c5367",
  null
  
)

export default component.exports